import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const updatePacienteSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    prontuario: Yup.string().notRequired(),
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),

    nomeMae: Yup.string().trim().notRequired(),
    nomeRepresentante: Yup.string().trim().notRequired(),
    raca: Yup.object().nullable().notRequired(),
    genero: Yup.object().nullable().notRequired(),
    nacionalidade: Yup.object().nullable().notRequired(),
    estadoNascimento: Yup.object().nullable().notRequired(),
    peso: Yup.string().trim().notRequired(),
    altura: Yup.string().trim().notRequired(),
    condicoes: Yup.string().trim().notRequired(),
  })
}
